import React from 'react'
import { Field } from 'formik'
import get from 'lodash/get'
import flatMap from 'lodash/flatMap'
import isEqual from 'lodash/isEqual'
import PropTypes from 'prop-types'

export default function FieldPair (props) {
  const {
    form,
    fieldAProps,
    fieldBProps,
    componentA,
    componentB,
    separator,
    label
  } = props

  const errors = [
    get(form.touched, fieldAProps.name) && get(form.errors, fieldAProps.name),
    get(form.touched, fieldBProps.name) && get(form.errors, fieldBProps.name)
  ]

  const errorDisplay = flatMap(
    isEqual(...errors) ? [errors[0]] : errors,
    error => {
      if (typeof error === 'string') {
        return <div className='expert-form__input-error'>{error}</div>
      } else if (error) {
        return Object.values(error).map(message => (
          <div key={message} className='expert-form__input-error'>
            {message}
          </div>
        ))
      } else {
        return null
      }
    }
  )

  return (
    <div className='expert-form__input-group'>
      <label className='expert-form__label'>{label}</label>
      <div className='expert-form__input-wrapper'>
        <div className='field-pair__wrapper'>
          <Field
            {...fieldAProps}
            renderError={() => null}
            component={componentA}
          />
          <span className='field-pair__separator'>{separator ? '—' : ''}</span>
          <Field
            {...fieldBProps}
            renderError={() => null}
            component={componentB}
          />
        </div>
        {errorDisplay}
      </div>
    </div>
  )
}

FieldPair.propTypes = {
  form: PropTypes.object.isRequired,
  fieldAProps: PropTypes.object.isRequired,
  fieldBProps: PropTypes.object.isRequired,
  componentA: PropTypes.func,
  componentB: PropTypes.func,
  separator: PropTypes.bool,
  label: PropTypes.string
}
